export { Popper, placements } from './popper';
export type {
	ManagerProps,
	ReferenceProps,
	PopperProps,
	PopperArrowProps,
	PopperChildrenProps,
	StrictModifier,
	Modifier,
	Placement,
} from './popper';

export { Manager, Reference } from 'react-popper';
